import { Button, Form } from 'antd';
import React, { useContext, useMemo, useState } from 'react';
import { DriverCard } from '../../components/driver_card.component';
import { MYCSearch, MYCSelect } from '../../components/input_form.component';
import { useGet, useGetPaginated } from '../../hooks/useRest.hook';
import { Endpoints } from '../../constants/endpoint.constant';
import { MYCPagination } from '../../components/table.component';
import { useForm } from 'antd/es/form/Form';
import { useNavigate } from 'react-router-dom';
import { DefaultOrigins } from '../../constants/origins.constant';
import { UserContext } from '../../App';
import { getRegionalOriginIds, isRegionalManagerRole } from '../../constants/general.constant';

const LicenceExpiryFilterOptions = [
    { value: "expired", label: "Expired" },
    { value: "expiring_30", label: "Expiring in 30 days" },
    { value: "expiring_60", label: "Expiring in 60 days" },
    { value: "expiring_90", label: "Expiring in 90 days" },
    { value: "missing", label: "Expiry date missing" },
    { value: "valid", label: "Valid beyond 90 days" },
];

export const DriversScreen = () => {
    const { user } = useContext(UserContext);
    const isRegionalManager = isRegionalManagerRole(user);
    const regionalOriginIds = useMemo(() => getRegionalOriginIds(user), [user]);
    const [query, setQuery] = useState({});
    const [form] = useForm();
    const originsRq = useGet(Endpoints.GET_ORIGINS);
    const origins = (Array.isArray(originsRq?.data) && originsRq.data.length > 0) ? originsRq.data : DefaultOrigins;
    const navigate = useNavigate();
    const effectiveQuery = useMemo(() => ({
        ...query,
        ...(isRegionalManager && regionalOriginIds.length === 1 ? { originId: regionalOriginIds[0] } : {}),
    }), [query, isRegionalManager, regionalOriginIds]);
    const driversRq = useGetPaginated(Endpoints.ALL_DRIVERS_TRIP_COUNT, true, effectiveQuery);
    return <>
        <span className='self-center text-lg'>Drivers List</span>
        <div className="self-center w-2/3 my-5">
            <div className="flex flex-row gap-5  justify-between">
                <Form form={form} onFinish={setQuery} layout="vertical">
                    <div className="flex items-end flex-row gap-5">
                        <MYCSearch name="driverName" className="flex-1" label="Search By Driver Name" />
                        {!isRegionalManager && <MYCSelect className="flex-1" options={
                            origins?.map?.(M => ({ value: M.id, label: M.name }))
                        } name="originId" label={"Region"} />}
                        <MYCSelect className="flex-1" options={LicenceExpiryFilterOptions} name="licenceExpiryFilter" label={"Licence Expiry"} />
                        <Button className="px-5" loading={driversRq?.loading} htmlType="submit" type="primary">Search</Button>
                        <Button
                            className="px-5"
                            onClick={() => {
                                form.resetFields();
                                setQuery({});
                            }}
                        >
                            Reset
                        </Button>
                    </div>
                </Form>
                {!isRegionalManager && <Button onClick={navigate?.bind(this,'/create-driver')} className="self-end px-10" type="primary">Create Driver</Button>}
            </div>
        </div>

        <div className="flex flex-col gap-5">
            {driversRq?.list?.map(D => <DriverCard key={D?.driver?.id} refresh={driversRq?.refresh} driver={D?.driver} totalTripCount = {D?.totalTripsCompleted} origins={origins} />)}
        </div>
        <MYCPagination {...driversRq} />
    </>
}
